<div class="flex font-secondary text-sm text-primary-1-900">
  <div class="stage-index h-4 w-4 text-xs flex justify-center text-grey/52 rounded-[1.875rem] bg-primary-1/10" [ngClass]="{ '!text-white !bg-primary-1': active }">
    <span class="m-auto">{{ index }}</span>
  </div>
  <div class="stage-name flex flex-col justify-center text-sm text-grey/52 ml-1" [ngClass]="{ '!text-primary-1': active }">{{ name }}</div>
</div>
